import { Field } from "#models/questionnaire";

export interface PickerProps {
  initData: AmPmTimeObj;
  width: number;
  open: EventTarget | null;
  handleClose: (value: string) => void;
}

export interface TimePickerProps {
  error: boolean;
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
}

export enum Shift {
  AM = 'AM',
  PM = 'PM'
}

export interface AmPmTimeObj {
  hour: string;
  minute: string;
  shift: Shift;
  timeString?: string;
}

export interface TimePickerFieldProps {
  field: Field;
  handleChangeFields: (type: string, value: any) => void;
}
